import type {IAvailability} from "@torim-app/types";
import {adminUrlBuilder} from "@app/api/utils";

export class AvailabilityApi {

  static readonly path = 'availability';

  static async fetchAvailability(): Promise<Record<string, IAvailability>> {
    const url = adminUrlBuilder({}, AvailabilityApi.path);
    const response = await fetch(url, {
      method: 'get',
      headers: {
        'content-type': 'application/json'
      }
    });
    if (!response.ok)
      throw "Failed to get availability";

    return await response.json();
  }

  static async updateAvailability(
    body: {userId?: string; availability: IAvailability}
  ): Promise<Record<string, IAvailability>> {
    const url = adminUrlBuilder({}, AvailabilityApi.path);
    const response = await fetch(url, {
      method: 'put',
      headers: {
        'content-type': 'application/json'
      },
      body: JSON.stringify(body)
    });
    if (!response.ok)
      throw `Failed to update availability`;

    return await response.json();
  }
}
